<script lang="ts" setup>
  import { userAction } from '../../../shared/observability/userAction.ts';
  import { MessageView } from '../../../shared/ui/message-view';

  defineEmits<{ goToStart: [] }>();
</script>

<template>
  <MessageView
    message="This game has ended: everyone left."
    :user-action-name="userAction.gameAbandonedGoToStart"
    @go-to-start="$emit('goToStart')"
  />
</template>
